import React, { useEffect, useState } from "react";
import axios from "axios";
import SavingsAccountModal from "../../components/SavingsAccountModal";
import styles from "../../styles/pages/loans_deposits.module.css";
import { MdOutlineDoubleArrow } from "react-icons/md";
import CurrentAccountModal from "../../components/CurrentAccountModal";
import { useAuth } from "../../authentication/AuthContext";

function CurrentAccount() {
  const [data, setData] = useState({
    eligibility: "",
    features: [],
    interestRate: "",
    documents: [],
  });
      const { isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(true); // Add loading state

  const fetchData = async () => {
    try {
      const res = await axios.get("/api/current-account");
      if (res.data) {
        setData(res.data || {}); // Set fetched data
      }
    } catch (err) {
      console.error("Error fetching content", err);
    } finally {
      setLoading(false); // Stop loading once the data is fetched
    }
  };

  useEffect(() => {
    fetchData();
  }, []); // Fetch data only once on component mount

  // Function to refresh data when it is updated
  const refreshData = () => {
    fetchData(); // Fetch the latest data
  };

  // Loading state
  if (loading) {
    return <div>Loading...</div>; // You can add a spinner or a more advanced loading state
  }

  return (
    <div className="body">
      <div className="heading">Current ACCOUNT SCHEME</div>
      <hr />
      <hr />
      
      {/* Pass the refreshData function to the modal */}
       {isAuthenticated  && (  
      <CurrentAccountModal refreshData={refreshData} />
       )} 
      <div className="body bordered_box">
        <div className={styles.subheading}>Eligibility</div>
        <div className={styles.text}>
          <p>{data.eligibility || "No data available"}</p>
        </div>

        <div className="break"></div>

        <div className={styles.subheading}>Features & Benefits:</div>
        <div className={styles.text}>
          {data.features.length > 0 ? (
            data.features.map((text, index) => (
              <p key={index}>
                <MdOutlineDoubleArrow /> {text}
              </p>
            ))
          ) : (
            <p>No features available</p>
          )}
        </div>

        <div className="break"></div>

        

        <div className={styles.subheading}>KYC Applicable As per RBI guidelines</div>
        
      </div>

      {/* Admin Modal for editing content */}
      
    </div>
  );
}

export default CurrentAccount;
